import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadFile } from '@/utils/helper';
import { $file, $http } from '@/axios';
import store from '@/store';

// 查询零件列表
export const queryFurComponents: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFurComponents', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/component/pagelist', payload);
    commit('setFurComponents', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setFurComponents', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询零件详情
export const queryFurComponentDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setFurComponentDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/component/${payload}/detail`);
    commit('setFurComponentDetail', { data: res, loading: false });
  } catch (e) {
    commit('setFurComponentDetail', { data: null, loading: false });
  }
};

// 查询光源轴向类型列表
export const queryAxialTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setAxialTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/AxialType');
    commit('setAxialTypes', { data: res });
  } catch (e) {
    commit('setAxialTypes', { data: [] });
  }
};

// 查询光源摆放类型列表
export const queryIlluminantTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setIlluminantTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/IlluminantType');
    commit('setIlluminantTypes', { data: res });
  } catch (e) {
    commit('setIlluminantTypes', { data: [] });
  }
};

// 编辑零件基本信息
export const editFurComponent: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/component/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除零件
export const deleteFurComponent: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/component/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架零件
export const shelfFurComponent: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/component/publish', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 刷新零件索引
export const refreshFurComponentIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新零件缩略图
export const updateFurComponentThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFurComponentThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/component/modifyimg', payload);
    commit('setFurComponentThumb', { data: res, loading: false });
  } catch (e) {
    commit('setFurComponentThumb', { data: null, loading: false });
  }
};

// 更新零件颜色信息
export const updateFurComponentColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  await $http.post('/v1/asset/component/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 新增价格(预留，暂时没接口)
export const addFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 编辑价格(预留，暂时没接口)
export const editFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出价格
export const exportFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {

    store.commit(commitType, { ...commitState, loading: true });
    const res: { blob: Blob; filename: string } = await $file.post('/v1/data/asset/component/exportprice', payload);
    downloadFile(res.blob, '零件价格列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入价格
export const importFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { type, file } = payload;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('/v1/asset/item/importprice', formData);
    store.commit('common/setToast', { visible: true, text: '价格导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出关键字(预留，暂时没接口)
export const exportFurComponentKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    const res: { blob: Blob; filename: string } = await $file.post('', payload);
    downloadFile(res.blob, '零件关键字列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入关键字
export const importFurComponentKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('/v1/asset/item/inputkeywords', formData);
    store.commit('common/setToast', { visible: true, text: '关键字导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 删除零件过滤项配置
export const deleteFurComponentFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/component/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存零件过滤项配置
export const saveFurComponentFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/component/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    return;
  }
};
